module.exports = __webpack_public_path__ + "static/img/stay-option-icon-bidet.798eea2f.svg";